// import React, { useState } from "react";
import firebase, { db } from "../firebase";
// import {useDispatch}
// import { useDispatch } from "react-redux";
// import { setOccupiedTopics } from "../../features/Questions/questionSlice";
// import { useHistory } from "react-router-dom";

function LoginHandle(provider) {
  // let history  = useHistory();
  const addEmail = async (email, uid) => {
    // console.log(email);
    var docRef = db.collection("user-details").doc(email);
    docRef
      .get()
      .then((doc) => {
        if (!doc.exists) {
          addEmailToDatabase(email, uid);
        }
        //  else console.log("already exists : ", email);
      })
      .catch((error) => {
        // console.log("Error getting document:", error);
      });
    // return await doc.exists;
  };

  const addEmailToDatabase = (email, uid) => {
    // console.log(email, uid);
    // Add a new document in collection "cities"
    db.collection("user-details")
      .doc(email)
      .set({
        uid: uid,
        occupiedPapers: ["FULL Paper 1"],
        dateOfJoin: firebase.firestore.FieldValue.serverTimestamp(),
      })
      .then(() => console.log("added email to db"))
      .catch((error) => {
        window.alert("An Error Occured : ");
        // console.log("error", error);
      });
  };

  firebase
    .auth()
    .signInWithPopup(provider)
    .then(async (result) => {
      /** @type {firebase.auth.OAuthCredential} */
      // var credential = result.credential;

      // This gives you a Google Access Token. You can use it to access the Google API.
      // var token = credential.accessToken;
      // The signed-in user info.
      var user = result.user;
      var email = user.email;
        addEmail(email, user.uid);
      // history.push("/");

      // console.log("success signin",user);
      // console.log(user);
    })
    .catch((error) => {
      // Handle Errors here.
      var errorCode = error.code;
      var errorMessage = error.message;
      // window.alert("error");
      // window.alert(errorCode);
      // console.log(errorMessage);
      // The email of the user's account used.
      // var email = error.email;
      // The firebase.auth.AuthCredential type that was used.
      // var credential = error.credential;
      // ...
    });

  return null;
}

export default LoginHandle;
